import { render, staticRenderFns } from "./DeviceDetails.vue?vue&type=template&id=54f0c814&scoped=true"
import script from "./DeviceDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeviceDetails.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DeviceDetails.vue?vue&type=style&index=0&id=54f0c814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f0c814",
  null
  
)

export default component.exports